import React from 'react';
import { TbError404 } from 'react-icons/tb';
import { MdWarning, MdArrowBack } from 'react-icons/md';
import { Link } from 'react-router-dom';

function NotFound() {
  return (
    <div className="h-full flex flex-col items-center justify-center">
      <div>
        <TbError404 size={180} />
      </div>
      <div className="flex items-center space-x-4 mb-8">
        <MdWarning size={50} color="var(--warning)" />
        <h2 className="text-2xl">Page introuvable</h2>
      </div>
      <Link className="flex items-center text-lg space-x-1 bg-zinc-700 py-2 px-4 hover:bg-zinc-600 duration-300 rounded" to="/">
        <MdArrowBack /> <span>Retour</span>
      </Link>
    </div>
  );
}

export default NotFound;
